import { CommonModel } from 'services/Main/common_services';
import { commonPresenter, commonStore } from 'stores/root_store';

// Params common
export type ParamsCommon = Partial<{
  catalogTypeCode: string;
  keyword: string;
}>;

type Props = {
  params?: ParamsCommon;
  onSetDropdown?: (values: CommonModel[]) => void;
};

// dropdown catalog Common ( danh mục dùng chung)  = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = =
export const getDropdownCatalog = async (props: Props) => {
  await commonPresenter.getCommonDataByKey(commonStore, props.params?.catalogTypeCode || '');
  if (commonStore.commonRespone.isSuccess) {
    if (props.onSetDropdown) {
      props.onSetDropdown(commonStore.commonRespone.data);
    }
  }
};